/**
 * True when running inside the Tauri webview. Tauri v2 injects
 * `__TAURI_INTERNALS__` on the global. We avoid importing `@tauri-apps/api`
 * here so this is safe + side-effect-free to import in the web build.
 */
export function isTauri(): boolean {
  return typeof globalThis !== 'undefined' && '__TAURI_INTERNALS__' in globalThis;
}
